export default __webpack_public_path__ + "341106b6011a0727ab965d424953c4ce.png";